import Rollbar from "rollbar";

const rollbarConfig = new Rollbar({
  enabled: process.env.VUE_APP_ENV === "production",
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  environment: process.env.VUE_APP_ENV,
  captureUncaught: false,
  captureUnhandledRejections: false,
})

export default rollbarConfig
